import { render, staticRenderFns } from "./StrategyPositionPreviewModal.vue?vue&type=template&id=6b97d450&scoped=true"
import script from "./StrategyPositionPreviewModal.vue?vue&type=script&lang=js"
export * from "./StrategyPositionPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./StrategyPositionPreviewModal.vue?vue&type=style&index=0&id=6b97d450&prod&scoped=true&lang=css"
import style1 from "./StrategyPositionPreviewModal.vue?vue&type=style&index=1&id=6b97d450&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_e128dc07b65f661f3a32bbc83dd42e36/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b97d450",
  null
  
)

export default component.exports